// app.routes.ts
import { Routes } from '@angular/router';
import { Layout } from '@ui-nuvertos/layout';
import { ModuleEnabledGuard } from '@ui-nuvertos/auth';
// import { PermissionGuard } from '@ui-nuvertos/auth';
import { favbarButtons, sidebarItems, searchModuleOptions } from './layout.config';

export const appRoutes: Routes = [
  // Redirect root to dashboard once
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Shell route rendered only for non-auth pages
  {
    path: '',
    component: Layout,
    data: { favbarButtons, sidebarItems, searchModuleOptions },
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./app').then((m) => m.AppComponent),
        data: { preload: true, module_id: 1, breadcrumb: 'Dashboard' }, // Critical route - preload
      },
      {
        path: 'vendors',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Vendor', module_key: 'vendors' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-list/vendor-list').then(
                (m) => m.VendorList
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 1,
              breadcrumb: 'List',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  { label: 'Create Vendor', route: '/vendors/onboarding' },
                ],
              },
            },
          },
          {
            path: 'onboarding', // /vendors/onboarding
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/vendor-onboarding/vendor-onboarding'
              ).then((m) => m.VendorOnboardingComponent),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 2,
              breadcrumb: 'Vendor Onboarding',
            },
          },
          {
            path: 'purchase-order/list', // /vendors/onboarding
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-po-list/vendor-po-list').then(
                (m) => m.VendorPoList
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 1,
              breadcrumb: 'Purchase Order',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  { label: 'Create PO', route: '/vendors/purchase-order' },
                ],
              },
            },
          },
          {
            path: 'purchase-order', // /vendors/onboarding
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-po/vendor-po').then(
                (m) => m.VendorPo
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 1,
              breadcrumb: 'Purchase Order Form',
            },
          },
          {
            path: 'dynamic-form', // /vendors/dynamic-form
            loadComponent: () =>
              import('@ui-nuvertos/shared/dynamic-form/dynamic-form').then(
                (m) => m.DynamicForm
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 2, breadcrumb: 'Dynamic Form' },
          },
          // {
          //   path: 'purchase', // /vendors/purchase
          //   loadComponent: () => import('../../../../libs/shared/src/lib/dynamic-form/dynamic-form').then(m => m.DynamicForm),
          //   // canActivate: [PermissionGuard],
          //   data: { module_id: 2, sub_module_id: 2 }
          // },
          // {
          //   path: 'return', // /vendors/purchase/return
          //   loadComponent: () => import('../../../../libs/shared/src/lib/vendor-return/vendor-return').then(m => m.VendorReturn),
          //   // canActivate: [PermissionGuard],
          //   data: { module_id: 2, sub_module_id: 3 }
          // },
          {
            path: 'sale',
            loadComponent: () =>
              import('@ui-nuvertos/shared/dynamic-form/dynamic-form').then(
                (m) => m.DynamicForm
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 2, sub_module_id: 4, breadcrumb: 'Sale' },
          },
          {
            path: 'sale/return',
            loadComponent: () =>
              import('@ui-nuvertos/shared/dynamic-form/dynamic-form').then(
                (m) => m.DynamicForm
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 2, sub_module_id: 5, breadcrumb: 'Sale Return' },
          },
          {
            path: 'vendor-payment-list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/vendor-payment-list/vendor-payment-list'
              ).then((m) => m.VendorPaymentList),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 5,
              breadcrumb: 'Vendor Payment',
              actions: {
                showFavorite: false,
                showSettings: false,
                showBulkUpload: true,
                redirectButtons: [
                  {
                    label: 'Create Vendor Payment',
                    route: '/vendors/vendor-payment',
                  }
                ],
              },
            },
          },
          {
            path: 'debit-note/list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/debit-note-list/debit-note-list'
              ).then((m) => m.DebitNoteList),
            data: {
              module_id: 2,
              sub_module_id: 6,
              breadcrumb: 'Debit Note',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  { label: 'Create Debit Note', route: '/vendors/debit-note' },
                ],
              },
            },
          },
          {
            path: 'debit-note',
            loadComponent: () =>
              import('@ui-nuvertos/shared/debit-note/debit-note').then(
                (m) => m.DebitNote
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 2, sub_module_id: 7, breadcrumb: 'Debit Note' },
          },
          {
            path: 'vendor-payment',
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-payment/vendor-payment').then(
                (m) => m.VendorPaymentComponent
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 7,
              breadcrumb: 'Vendor Bill Payment',
            },
          },
          {
            path: 'grn/create',
            // loadComponent: () => import('../../../../libs/shared/src/lib/vendor/vendor-grn/vendor-grn').then(m => m.VendorGrn),
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor/vendor-grn/vendor-grn').then(
                (m) => m.VendorGrn
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 8,
              breadcrumb: 'Item Receipt GRN',
            },
          },
          {
            path: 'grn',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/vendor-grn/vendor-grn-list/vendor-grn-list'
              ).then((m) => m.VendorGrnList),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 10,
              breadcrumb: 'GRN',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  { label: 'Create GRN', route: '/vendors/grn/create' },
                ],
              },
            },
          },
          {
            path: 'advancePayment',
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-payment/vendor-payment').then(
                (m) => m.VendorPaymentComponent
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 10,
              breadcrumb: 'Advance Payment',
            },
          },
          {
            path: 'purchase-invoice/list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/vendor/vendor-pi-list/vendor-pi-list'
              ).then((m) => m.VendorPiList),
            data: {
              module_id: 2,
              sub_module_id: 12,
              breadcrumb: 'Purchase Invoice',
              actions: {
                showFavorite: false,
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Purchase Invoice',
                    route: '/vendors/purchase-invoice',
                  },
                ],
              },
            },
          },
          {
            path: 'purchase-invoice', // /vendors/purchase
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-pi/vendor-pi').then(
                (m) => m.VendorPi
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 13,
              breadcrumb: 'Purchase Invoice',
            },
          },
          {
            path: 'return/list', // /vendors/return/list
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/vendor-return-list/vendor-return-list'
              ).then((m) => m.VendorReturnList),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 15,
              breadcrumb: 'Return',
              actions: {
                showBulkUpload: false,
                showFavorite: false,
                showBack: false,
                redirectButtons: [
                  { label: 'Create Return', route: '/vendors/return' },
                ],
              },
            },
          },
          {
            path: 'return', // /vendors/return
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-return/vendor-return').then(
                (m) => m.VendorReturn
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 2, sub_module_id: 14, breadcrumb: 'Return' },
          },
          {
            path: 'settlement',
            loadComponent: () =>
              import('@ui-nuvertos/shared/vendor-settlement/vendor-settlement').then(
                (m) => m.VendorSettlement
              ),
            data: {
              module_id: 2,
              sub_module_id: 20,
              breadcrumb: 'Vendor Settlement',
              actions: {
                showFavorite: false,
                showSettings: false,
                showBulkUpload: false,
              },
            },
          },
        ],
      },
      {
        path: 'vendor-ledger',
        data: { breadcrumb: 'Vendor Ledger' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../../features/vendor-ledger/vendor-ledger').then(
                (m) => m.VendorLedger
              ),
            data: {
              module_id: 2,
              sub_module_id: 11,
              breadcrumb: 'Vendor Ledger',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: false,
              },
            },
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../../features/vendor-ledger/vendor-ledger').then(
                (m) => m.VendorLedger
              ),
            data: {
              module_id: 2,
              sub_module_id: 11,
              breadcrumb: 'Vendor Ledger',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: false,
              },
            },
          },
        ],
      },
      {
        path: 'client-ledger',
        data: { breadcrumb: 'Client Ledger' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../../features/client-ledger/client-ledger').then(
                (m) => m.ClientLedger
              ),
            data: {
              module_id: 3,
              sub_module_id: 11,
              breadcrumb: 'Client Ledger',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: false,
              },
            },
          },
          {
            path: ':id',
            loadComponent: () =>
              import('../../features/client-ledger/client-ledger').then(
                (m) => m.ClientLedger
              ),
            data: {
              module_id: 3,
              sub_module_id: 11,
              breadcrumb: 'Client Ledger',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: false,
              },
            },
          },
        ],
      },
      {
        path: 'clients',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Client', module_key: 'clients' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-list/client-list').then(
                (m) => m.ClientList
              ),
            data: {
              module_id: 3,
              sub_module_id: 1,
              breadcrumb: 'List',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  { label: 'Add Client', route: '/clients/onboarding' },
                ],
              },
            },
          },
          {
            path: 'sales-order/list', // /vendors/onboarding
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-so-list/client-so-list').then(
                (m) => m.ClientSoList
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 1,
              breadcrumb: 'Sales Order',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  { label: 'Create SO', route: '/clients/sales-order' },
                ],
              },
            },
          },
          {
            path: 'sales-order', // /clients/sales-order
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-so/client-so').then(
                (m) => m.ClientSo
              ),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 2,
              sub_module_id: 1,
              breadcrumb: 'Sales Order Form',
            },
          },
          {
            path: 'client-invoice/list', // /clients/client-invoice/list - must be before client-invoice route
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client/client-invoice/list/client-invoice-list'
              ).then((m) => m.ClientInvoiceList),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 3,
              sub_module_id: 4,
              breadcrumb: 'Client Invoice',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Client Invoice',
                    route: '/clients/client-invoice',
                  },
                  {
                    label: 'Bulk E-Invoice',
                    route: '/einvoice/generate',
                  },
                ],
              },
            },
          },
          {
            path: 'client-invoice', // /clients/client-invoice
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client/client-invoice/form/client-pi'
              ).then((m) => m.ClientPi),
            // canActivate: [PermissionGuard],
            data: {
              module_id: 3,
              sub_module_id: 5,
              breadcrumb: 'Client Invoice Form',
            },
          },
          {
            path: 'onboarding',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client-onboarding/client-onboarding'
              ).then((m) => m.ClientOnboardingComponent),
            data: {
              module_id: 3,
              sub_module_id: 2,
              breadcrumb: 'Client Onboarding',
              actions: {
                showBulkUpload: false,
                showFavorite: false,
                showBack: true,
              },
            },
          },
          {
            path: 'client-payment',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-payment/client-payment').then(
                (m) => m.ClientPaymentComponent
              ),
            data: {
              module_id: 3,
              sub_module_id: 4,
              breadcrumb: 'Client Receipt',
            },
          },
          {
            path: 'advance-payment',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-payment/client-payment').then(
                (m) => m.ClientPaymentComponent
              ),
            data: {
              module_id: 3,
              sub_module_id: 5,
              breadcrumb: 'Advance Payment',
              paymentType: 'advance',
            },
          },
          {
            path: 'refund-payment',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-refund/client-refund').then(
                (m) => m.ClientRefundComponent
              ),
            data: {
              module_id: 3,
              sub_module_id: 6,
              breadcrumb: 'Issue Refund',
            },
          },
          {
            path: 'client-payment-list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client-payment-list/client-payment-list'
              ).then((m) => m.ClientPaymentList),
            data: {
              module_id: 3,
              sub_module_id: 3,
              breadcrumb: 'Client Receipt',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: true,
                redirectButtons: [
                  {
                    label: 'Receive Payment',
                    route: '/clients/client-payment',
                  },
                ],
              },
            },
          },
          {
            path: 'refund-payment/list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client-refund-list/client-refund-list'
              ).then((m) => m.ClientRefundList),
            data: {
              module_id: 3,
              sub_module_id: 7,
              breadcrumb: 'Refund',
              actions: {
                showFavorite: true,
                showSettings: true,
                showBulkUpload: false,
                redirectButtons: [
                  { label: 'Create Refund', route: '/clients/refund-payment' },
                ]
              },
            },
          },
          {
            path: 'return/list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/client-return-list/client-return-list'
              ).then((m) => m.ClientReturnList),
            data: {
              module_id: 3,
              sub_module_id: 6,
              breadcrumb: 'Client Return',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  { label: 'Create Return', route: '/clients/return' },
                ],
              },
            },
          },
          {
            path: 'return',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-return/client-return').then(
                (m) => m.ClientReturn
              ),
            data: {
              module_id: 3,
              sub_module_id: 6,
              breadcrumb: 'Client Return Form',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'credit-note/list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/credit-note-list/credit-note-list'
              ).then((m) => m.CreditNoteList),
            data: {
              module_id: 3,
              sub_module_id: 7,
              breadcrumb: 'Credit Note',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Credit Note',
                    route: '/clients/credit-note',
                  },
                  {
                    label: 'Bulk E-Invoice',
                    route: '/einvoice/generate',
                  },
                ],
              },
            },
          },
          {
            path: 'credit-note',
            loadComponent: () =>
              import('@ui-nuvertos/shared/credit-note/credit-note').then(
                (m) => m.CreditNote
              ),
            // canActivate: [PermissionGuard],
            data: { module_id: 3, sub_module_id: 7, breadcrumb: 'Credit Note' },
          },
          {
            path: 'settlement',
            loadComponent: () =>
              import('@ui-nuvertos/shared/client-settlement/client-settlement').then(
                (m) => m.ClientSettlement
              ),
            data: {
              module_id: 3,
              sub_module_id: 21,
              breadcrumb: 'Client Settlement',
              actions: {
                showFavorite: false,
                showSettings: false,
                showBulkUpload: false,
              },
            },
          },
        ],
      },
      {
        path: 'items',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Items', module_key: 'items' },
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/item-list/item-list').then(
                (m) => m.ItemList
              ),
            data: {
              module_id: 4,
              sub_module_id: 1,
              breadcrumb: 'Item Master List',
              actions: {
                showBulkUpload: true,
                showBack: false,
                redirectButtons: [{ label: 'Create Item', route: '/items' }],
              },
            },
          },
          {
            path: '',
            loadComponent: () =>
              import('@ui-nuvertos/shared/item-master/item-master').then(
                (m) => m.ItemMaster
              ),
            data: {
              module_id: 4,
              sub_module_id: 2,
              breadcrumb: 'Create Item',
              actions: {
                showBulkUpload: false,
              },
            },
          },
        ],
      },
      {
        path: 'assets',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Assets', module_key: 'asset' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-dashboard/asset-dashboard').then(
                (m) => m.AssetDashboard
              ),
            data: {
              module_id: 12,
              sub_module_id: 0,
              breadcrumb: 'Dashboard',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  { label: 'Add Asset', route: '/assets/add' },
                ],
                actionButtons: [
                  { label: 'Run Depreciation', action: 'run-depreciation', icon: 'pi pi-calculator' },
                ],
              },
            },
          },
          {
            path: 'my-assets',
            loadComponent: () =>
              import('@ui-nuvertos/shared/my-assets/my-assets').then(
                (m) => m.MyAssets
              ),
            data: {
              module_id: 12,
              sub_module_id: 0,
              breadcrumb: 'My Assets',
              actions: {
                showBulkUpload: false,
                showBack: false,
              },
            },
          },
          {
            path: 'add',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-create/asset-create').then(
                (m) => m.AssetCreate
              ),
            data: {
              module_id: 12,
              sub_module_id: 2,
              mode: 'create',
              breadcrumb: 'Add Asset',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'asset-request/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-request-list/asset-request-list').then(
                (m) => m.AssetRequestList
              ),
            data: {
              module_id: 12,
              sub_module_id: 1,
              breadcrumb: 'Asset Request',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  { label: 'Create Asset Request', route: '/assets/asset-request/create' },
                ],
              },
            },
          },
          {
            path: 'asset-request/create',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-request/asset-request').then(
                (m) => m.AssetRequest
              ),
            data: {
              module_id: 12,
              sub_module_id: 1,
              mode: 'create',
              breadcrumb: 'Asset Request Form',
            },
          },
          {
            path: 'asset-request/:requestId/fulfillment',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/asset-fulfillment/asset-fulfillment'
              ).then((m) => m.AssetFulfillmentComponent),
            data: {
              module_id: 12,
              sub_module_id: 1,
              breadcrumb: 'Fulfillment',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'asset-request/:id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-request/asset-request').then(
                (m) => m.AssetRequest
              ),
            data: {
              module_id: 12,
              sub_module_id: 1,
              mode: 'edit',
              breadcrumb: 'Asset Request Form',
            },
          },
          {
            path: 'transfers/create',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-transfer/asset-transfer').then(
                (m) => m.AssetTransfer
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              mode: 'create',
              breadcrumb: 'Transfer Asset',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'transfers/:id/in-transit',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-transfer/asset-transfer').then(
                (m) => m.AssetTransfer
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              mode: 'in_transit',
              breadcrumb: 'In Transit',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'transfers/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-transfer-list/asset-transfer-list').then(
                (m) => m.AssetTransferList
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              breadcrumb: 'Asset Transfers',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Transfer Asset',
                    route: '/assets/transfers/create',
                  },
                ],
              },
            },
          },
          {
            path: 'transfers/:id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-transfer/asset-transfer').then(
                (m) => m.AssetTransfer
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              // Without this AssetTransfer falls back to 'create' (asset-transfer.ts:107),
              // renders an empty form and Save calls createTransfer -- so opening an
              // approval from the dashboard produced a SECOND transfer for the asset
              // under review. write-offs/:id and removals/:id already set it.
              mode: 'view',
              breadcrumb: 'View Transfer',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'procurement-queue',
            loadComponent: () =>
              import('@ui-nuvertos/shared/procurement-queue-list/procurement-queue-list').then(
                (m) => m.ProcurementQueueList
              ),
            data: {
              module_id: 12,
              sub_module_id: 4,
              breadcrumb: 'Procurement Queue',
              actions: {
                showBulkUpload: false,
                showBack: false,
              },
            },
          },
          {
            path: 'assignments/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/assignment-list/assignment-list').then(
                (m) => m.AssignmentList
              ),
            data: {
              module_id: 12,
              sub_module_id: 5,
              breadcrumb: 'Asset Assignments',
              actions: {
                showBulkUpload: false,
                showBack: false,
              },
            },
          },
          {
            path: ':id/recover',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-recover/asset-recover').then(
                (m) => m.AssetRecover
              ),
            data: {
              module_id: 12,
              sub_module_id: 2,
              mode: 'create',
              breadcrumb: 'Recover Asset',
            },
          },
          {
            path: ':id/assign',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-assignment/asset-assignment').then(
                (m) => m.AssetAssignment
              ),
            data: {
              module_id: 12,
              sub_module_id: 2,
              mode: 'create',
              breadcrumb: 'Assign Asset',
            },
          },
          {
            path: 'write-offs/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-write-off-list/asset-write-off-list').then(
                (m) => m.AssetWriteOffList
              ),
            data: {
              module_id: 12,
              sub_module_id: 4,
              breadcrumb: 'Asset Write-Offs',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Write-Off',
                    route: '/assets/write-offs/create',
                  },
                ],
              },
            },
          },
          {
            path: 'write-offs/create',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-write-off/asset-write-off').then(
                (m) => m.AssetWriteOff
              ),
            data: {
              module_id: 12,
              sub_module_id: 4,
              mode: 'create',
              breadcrumb: 'Create Write-Off',
              actions: { showBack: true },
            },
          },
          {
            path: 'write-offs/:id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-write-off/asset-write-off').then(
                (m) => m.AssetWriteOff
              ),
            data: {
              module_id: 12,
              sub_module_id: 4,
              mode: 'view',
              breadcrumb: 'View Write-Off',
              actions: { showBack: true },
            },
          },
          {
            path: 'write-offs/:id/edit',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-write-off/asset-write-off').then(
                (m) => m.AssetWriteOff
              ),
            data: {
              module_id: 12,
              sub_module_id: 4,
              mode: 'edit',
              breadcrumb: 'Edit Write-Off',
              actions: { showBack: true },
            },
          },
          {
            path: 'removals/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-remove-list/asset-remove-list').then(
                (m) => m.AssetRemoveList
              ),
            data: {
              module_id: 12,
              sub_module_id: 6,
              breadcrumb: 'Asset Removals',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Removal',
                    route: '/assets/removals/create',
                  },
                ],
              },
            },
          },
          {
            path: 'removals/create',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-remove/asset-remove').then(
                (m) => m.AssetRemoveComponent
              ),
            data: {
              module_id: 12,
              sub_module_id: 6,
              mode: 'create',
              breadcrumb: 'Create Removal',
              actions: { showBack: true },
            },
          },
          {
            path: 'removals/:id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-remove/asset-remove').then(
                (m) => m.AssetRemoveComponent
              ),
            data: {
              module_id: 12,
              sub_module_id: 6,
              mode: 'view',
              breadcrumb: 'View Removal',
              actions: { showBack: true },
            },
          },
          {
            path: 'removals/:id/edit',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-remove/asset-remove').then(
                (m) => m.AssetRemoveComponent
              ),
            data: {
              module_id: 12,
              sub_module_id: 6,
              mode: 'edit',
              breadcrumb: 'Edit Removal',
              actions: { showBack: true },
            },
          },
          {
            path: 'asset-maintenance-requests/list',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-maintenance-request-list/asset-maintenance-request-list').then(
                (m) => m.AssetMaintenanceRequestList
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              breadcrumb: 'Maintenance Requests',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Maintenance Request',
                    route: '/assets/asset-maintenance-requests/create',
                  },
                ],
              },
            },
          },
          {
            path: 'my-maintenance-requests',
            loadComponent: () =>
              import('@ui-nuvertos/shared/my-maintenance-requests/my-maintenance-requests').then(
                (m) => m.MyMaintenanceRequests
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              breadcrumb: 'My Maintenance Requests',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Maintenance Request',
                    route: '/assets/asset-maintenance-requests/create',
                  },
                ],
              },
            },
          },
          {
            path: 'asset-maintenance-requests/create',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-maintenance-request/asset-maintenance-request').then(
                (m) => m.MaintenanceRequest
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              mode: 'create',
              breadcrumb: 'Create Maintenance Request',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: 'asset-maintenance-requests/:id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-maintenance-request/asset-maintenance-request').then(
                (m) => m.MaintenanceRequest
              ),
            data: {
              module_id: 12,
              sub_module_id: 3,
              mode: 'view',
              breadcrumb: 'Maintenance Request',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
          {
            path: ':id',
            loadComponent: () =>
              import('@ui-nuvertos/shared/asset-create/asset-create').then(
                (m) => m.AssetCreate
              ),
            data: {
              module_id: 12,
              sub_module_id: 2,
              breadcrumb: 'Asset Details',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
        ],
      },
      {
        path: 'inventory',
        canActivate: [ModuleEnabledGuard],
        loadComponent: () =>
          import('@ui-nuvertos/shared/inventory-list/inventory-list').then(
            (m) => m.InventoryList
          ),
        data: {
          module_id: 8,
          module_key: 'inventory',
          breadcrumb: 'Inventory / List',
          actions: {
            showBulkUpload: true,
            showBack: false,
            redirectButtons: [
              { label: 'Add Item', route: '/items' },
            ],
          },
        },
      },
      {
        path: 'inventory/:id/ledger',
        canActivate: [ModuleEnabledGuard],
        loadComponent: () =>
          import(
            '../../../inventory/features/inventory-ledger/inventory-ledger'
          ).then((m) => m.InventoryLedger),
        data: {
          module_id: 8,
          module_key: 'inventory',
          breadcrumb: 'Inventory Ledger',
          actions: {
            showBulkUpload: false,
            showBack: true,
          },
        },
      },
      {
        path: 'inventory-adjustment',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Inventory Adjustment', module_key: 'inventory' },
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/inventory-adjustment-list/inventory-adjustment-list'
              ).then((m) => m.InventoryAdjustmentList),
            data: {
              module_id: 8,
              sub_module_id: 2,
              breadcrumb: 'Adjustment List',
              actions: {
                showBulkUpload: false,
                showBack: false,
                redirectButtons: [
                  {
                    label: 'Create Adjustment',
                    route: '/inventory-adjustment',
                  },
                ],
              },
            },
          },
          {
            path: '',
            loadComponent: () =>
              import(
                '@ui-nuvertos/shared/inventory-adjustment/inventory-adjustment'
              ).then((m) => m.InventoryAdjustmentComponent),
            data: {
              module_id: 8,
              sub_module_id: 3,
              breadcrumb: 'Inventory Adjustment',
              actions: {
                showBulkUpload: false,
                showBack: true,
              },
            },
          },
        ],
      },
      {
        path: 'clinical',
        loadComponent: () => import('./app').then((m) => m.AppComponent),
        // canActivate: [PermissionGuard],
        data: { preload: false, module_id: 4, breadcrumb: 'Clinical' },
      },
      {
        path: 'approvals',
        canActivate: [ModuleEnabledGuard],
        loadComponent: () =>
          import('./approvals/pending-approvals-page.component').then(
            (m) => m.PendingApprovalsPageComponent
          ),
        // canActivate: [PermissionGuard],
        data: {
          preload: false,
          module_id: 4,
          module_key: 'settings',
          breadcrumb: 'Pending Approvals',
          actions: {
            showFavorite: false,
            showSettings: false,
            showBulkUpload: false,
          },
        },
      },
      {
        path: 'appointments',
        loadComponent: () => import('./app').then((m) => m.AppComponent),
        // canActivate: [PermissionGuard],
        data: { preload: false, module_id: 5, breadcrumb: 'Appointments' },
      },
      // {
      //   path: 'finance',
      //   loadComponent: () => import('@ui-nuvertos/shared/vendor-po/vendor-po').then(m => m.VendorPo),
      //   // canActivate: [PermissionGuard],
      //   data: { preload: false, module_id: 6 }
      // },
      {
        path: 'exports',
        loadComponent: () =>
          import('@ui-nuvertos/shared/exports-list/exports-list.component').then(
            (m) => m.ExportsListComponent
          ),
        data: {
          breadcrumb: 'Manage Exports',
          actions: {
            showFavorite: false,
            showSettings: false,
            showBulkUpload: false,
            showBack: true,
          },
        },
      },
      {
        path: 'uploads',
        loadComponent: () =>
          import('@ui-nuvertos/shared/uploads-list/uploads-list.component').then(
            (m) => m.UploadsListComponent
          ),
        data: {
          breadcrumb: 'Manage Uploads',
          actions: {
            showFavorite: false,
            showSettings: false,
            showBulkUpload: false,
            showBack: true,
          },
        },
      },
      {
        path: 'einvoice/generate',
        loadComponent: () =>
          import('@ui-nuvertos/shared/einvoice-generate/einvoice-generate.component').then(
            (m) => m.EInvoiceGenerateComponent
          ),
        data: {
          breadcrumb: 'Generate E-Invoice',
          actions: { showBack: true },
        },
      },
      {
        path: 'einvoice/jobs',
        loadComponent: () =>
          import('@ui-nuvertos/shared/einvoice-jobs-list/einvoice-jobs-list.component').then(
            (m) => m.EInvoiceJobsListComponent
          ),
        data: {
          breadcrumb: 'E-Invoice Jobs',
          actions: { showBack: true },
        },
      },
      {
        path: 'department',
        canActivate: [ModuleEnabledGuard],
        loadComponent: () => import('./app').then((m) => m.AppComponent),
        // canActivate: [PermissionGuard],
        data: { preload: false, module_id: 9, module_key: 'masters', breadcrumb: 'Department' },
      },
      {
        path: 'settings',
        canActivate: [ModuleEnabledGuard],
        data: { preload: true, module_id: 10, module_key: 'settings', breadcrumb: 'Settings' },
        children: [
          {
            path: '',
            redirectTo: 'masters',
            pathMatch: 'full',
          },
          {
            path: 'masters',
            data: { breadcrumb: 'Masters' },
            children: [
              {
                path: '',
                redirectTo: 'terms',
                pathMatch: 'full',
              },
              ...generateMasterRoutes(),
            ],
          },
          {
            path: 'account_settings',
            data: { breadcrumb: 'Account Settings' },
            children: [
              {
                path: '',
                redirectTo: 'users',
                pathMatch: 'full',
              },
              {
                path: 'roles',
                loadComponent: () =>
                  import('@ui-nuvertos/settings').then(
                    (m) => m.RolesTabComponent
                  ),
                data: {
                  breadcrumb: 'Roles',
                  module_id: 10,
                  sub_module_id: 13,
                  actions: {
                    showFavorite: true,
                    showSettings: true,
                    showBulkUpload: false,
                    redirectButtons: [],
                  },
                },
              },
              {
                path: 'roles/:roleId/permissions',
                loadComponent: () =>
                  import('@ui-nuvertos/settings').then(
                    (m) => m.PermissionMatrixComponent
                  ),
                data: { breadcrumb: 'Role Permissions' },
              },
              {
                path: 'user-roles',
                loadComponent: () =>
                  import('@ui-nuvertos/settings').then(
                    (m) => m.UserRoleAssignmentComponent
                  ),
                data: {
                  breadcrumb: 'User Roles',
                  module_id: 10,
                  sub_module_id: 13,
                  actions: {
                    showFavorite: true,
                    showSettings: true,
                    showBulkUpload: false,
                    redirectButtons: [],
                  },
                },
              },
              ...generateAccountSettingsRoutes(),
            ],
          },
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./settings/settings-dashboard.component').then(
                (m) => m.SettingsDashboardComponent
              ),
            data: { breadcrumb: 'Settings Dashboard', preload: true },
          },
          {
            path: 'sequence-config',
            loadComponent: () =>
              import(
                './settings/sequence-config/sequence-config.component'
              ).then((m) => m.SequenceConfigComponent),
            data: { breadcrumb: 'Sequence Configuration', preload: true },
          },
          {
            path: 'pdf-settings',
            loadComponent: () =>
              import('./settings/pdf-settings.component').then(
                (m) => m.PdfSettingsComponent
              ),
            data: { breadcrumb: 'PDF Settings', preload: true },
          },
          {
            path: 'accounting-dimensions',
            loadComponent: () =>
              import(
                '../../features/accounting-dimensions/accounting-dimensions'
              ).then((m) => m.AccountingDimensions),
            data: {
              breadcrumb: 'Accounting Dimensions',
              preload: false,
              module_id: 10,
              sub_module_id: 16,
              actions: {
                showFavorite: true,
                showSettings: false,
                showBulkUpload: false,
              },
            },
          },
          {
            path: 'approval-workflows',
            data: { breadcrumb: 'Approval Workflows' },
            children: [
              {
                path: '',
                loadComponent: () =>
                  import(
                    './approvals/approval-workflows-list-page.component'
                  ).then((m) => m.ApprovalWorkflowsListPageComponent),
                data: {
                  module_id: 10,
                  sub_module_id: 11,
                  breadcrumb: 'List',
                  actions: {
                    showFavorite: false,
                    showSettings: false,
                    showBulkUpload: false,
                    showBack: false,
                    redirectButtons: [
                      {
                        label: 'Create Workflow',
                        route: '/settings/approval-workflows/create',
                      },
                    ],
                  },
                },
              },
              {
                path: 'create',
                loadComponent: () =>
                  import('./settings/approval-settings.component').then(
                    (m) => m.ApprovalSettingsComponent
                  ),
                data: {
                  module_id: 10,
                  sub_module_id: 11,
                  breadcrumb: 'Create Workflow',
                  actions: {
                    showFavorite: false,
                    showSettings: false,
                    showBulkUpload: false,
                    showBack: true,
                  },
                },
              },
              {
                path: 'view',
                loadComponent: () =>
                  import('./settings/approval-settings.component').then(
                    (m) => m.ApprovalSettingsComponent
                  ),
                data: {
                  module_id: 10,
                  sub_module_id: 11,
                  breadcrumb: 'View Workflow',
                  actions: {
                    showFavorite: false,
                    showSettings: false,
                    showBulkUpload: false,
                    showBack: true,
                  },
                },
              },
              {
                path: 'edit',
                loadComponent: () =>
                  import('./settings/approval-settings.component').then(
                    (m) => m.ApprovalSettingsComponent
                  ),
                data: {
                  module_id: 10,
                  sub_module_id: 11,
                  breadcrumb: 'Edit Workflow',
                  actions: {
                    showFavorite: false,
                    showSettings: false,
                    showBulkUpload: false,
                    showBack: true,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        path: 'reports',
        canActivate: [ModuleEnabledGuard],
        loadChildren: () =>
          import('./features/reports/reports-module').then(
            (m) => m.ReportsModule
          ),
        // canActivate: [PermissionGuard],
        data: { preload: false, module_id: 8, module_key: 'accounting', breadcrumb: 'Reports' },
      },
      {
        path: 'finance',
        canActivate: [ModuleEnabledGuard],
        data: { breadcrumb: 'Finance', module_key: 'accounting' },
        children: [
          {
            path: 'journal-vouchers',
            loadChildren: () =>
              import(
                '../../features/journal-voucher/journal-voucher-routing.module'
              ).then((m) => m.JournalVoucherRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 1,
              breadcrumb: 'Journal Vouchers',
            },
          },
          {
            path: 'transaction-details',
            loadChildren: () =>
              import(
                '../../features/transaction-details/transaction-details-routing.module'
              ).then((m) => m.TransactionDetailsRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 2,
              breadcrumb: 'Transaction Details',
            },
          },
          {
            path: 'income-statement',
            loadChildren: () =>
              import(
                '../../features/income-statement/income-statement-routing.module'
              ).then((m) => m.IncomeStatementRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 3,
              breadcrumb: 'Income Statement',
            },
          },
          {
            path: 'income-statement-summary',
            loadChildren: () =>
              import(
                '../../features/income-statement-summary/income-statement-summary-routing.module'
              ).then((m) => m.default),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 13,
              breadcrumb: 'Income Statement Summary',
            },
          },
          {
            path: 'general-ledger',
            loadChildren: () =>
              import(
                '../../features/general-ledger/general-ledger-routing.module'
              ).then((m) => m.GeneralLedgerRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 4,
              breadcrumb: 'General Ledger',
            },
          },
          {
            path: 'trial-balance',
            loadChildren: () =>
              import(
                '../../features/trial-balance/trial-balance-routing.module'
              ).then((m) => m.TrialBalanceRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 5,
              breadcrumb: 'Trial Balance',
            },
          },
          {
            path: 'balance-sheet',
            loadChildren: () =>
              import(
                '../../features/balance-sheet/balance-sheet-routing.module'
              ).then((m) => m.BalanceSheetRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 16,
              breadcrumb: 'Balance Sheet',
            },
          },
          {
            path: 'chart-of-accounts',
            loadChildren: () =>
              import(
                '../../features/chart-of-accounts/chart-of-accounts-routing.module'
              ).then((m) => m.ChartOfAccountsRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 6,
              breadcrumb: 'Chart of Accounts',
            },
          },
          {
            path: 'ap-aging-summary',
            loadChildren: () =>
              import(
                '../../features/ap-aging-summary/ap-aging-summary-routing.module'
              ).then((m) => m.APAgingSummaryRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 7,
              breadcrumb: 'AP Aging Summary',
            },
          },
          {
            path: 'ap-aging-details',
            loadChildren: () =>
              import(
                '../../features/ap-aging-details/ap-aging-details-routing.module'
              ).then((m) => m.APAgingDetailsRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 8,
              breadcrumb: 'AP Aging Details',
            },
          },
          {
            path: 'ar-aging-summary',
            loadChildren: () =>
              import(
                '../../features/ar-aging-summary/ar-aging-summary-routing.module'
              ).then((m) => m.default),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 9,
              breadcrumb: 'AR Aging Summary',
            },
          },
          {
            path: 'ar-aging-details',
            loadChildren: () =>
              import(
                '../../features/ar-aging-details/ar-aging-details-routing.module'
              ).then((m) => m.default),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 10,
              breadcrumb: 'AR Aging Details',
            },
          },
          {
            path: 'purchase-report',
            loadChildren: () =>
              import(
                '../../features/purchase-report/purchase-report-routing.module'
              ).then((m) => m.PurchaseReportRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 13,
              breadcrumb: 'Purchase Report',
            },
          },
          {
            path: 'sales-order-report',
            loadChildren: () =>
              import(
                '../../features/sales-order-report/sales-order-report-routing.module'
              ).then((m) => m.SalesOrderReportRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              breadcrumb: 'Sales Order Report',
            },
          },
          {
            path: 'gl-search',
            loadChildren: () =>
              import(
                '../../features/gl-search/gl-search-routing.module'
              ).then((m) => m.GLSearchRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 18,
              breadcrumb: 'GL Search',
            },
          },
          {
            path: 'ap-register',
            loadChildren: () =>
              import(
                '../../features/ap-register/ap-register-routing.module'
              ).then((m) => m.APRegisterRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 11,
              breadcrumb: 'AP Register',
            },
          },
          {
            path: 'ar-register',
            loadChildren: () =>
              import(
                '../../features/ar-register/ar-register-routing.module'
              ).then((m) => m.default),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 12,
              breadcrumb: 'AR Register',
            },
          },
          {
            path: 'ap-payment-history',
            loadChildren: () =>
              import(
                '../../features/ap-payment-history/ap-payment-history-routing.module'
              ).then((m) => m.APPaymentHistoryRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 17,
              breadcrumb: 'A/P Payment History',
            },
          },
          {
            path: 'open-purchase-invoices',
            loadChildren: () =>
              import(
                '../../features/open-purchase-invoices/open-purchase-invoices-routing.module'
              ).then((m) => m.OpenPurchaseInvoicesRoutingModule),
            data: {
              preload: false,
              module_id: 7,
              sub_module_id: 14,
              breadcrumb: 'Open Purchase Invoices',
            },
          },
        ],
      },
    ],
  },

  // Routes outside the shell (e.g., auth)
  {
    path: 'login',
    loadComponent: () =>
      import('@ui-nuvertos/shared/login/login').then((m) => m.Login),
    data: { layout: 'none', preload: true, breadcrumb: 'Login' }, // Do not render topbar/favbar/sidebar
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('@ui-nuvertos/shared/unauthorized/unauthorized').then(
        (m) => m.Unauthorized
      ),
    data: { layout: 'none', preload: false, breadcrumb: 'Unauthorized' }, // Do not render topbar/favbar/sidebar
  },

  // Fallback
  { path: '**', redirectTo: 'dashboard' },
];

function generateMasterRoutes(): Routes {
  const settingsItem = sidebarItems.find((item) => item.key === 'settings');
  if (!settingsItem?.children) return [];

  const mastersItem = settingsItem.children.find(
    (child: any) => child.label === 'Masters'
  ) as any;
  if (!mastersItem?.children) return [];

  // Standalone components that have custom behavior
  const componentMap: { [key: string]: () => Promise<any> } = {
    'chart-of-accounts': () =>
      import(
        '@ui-nuvertos/shared/masters/chart-of-accounts/chart-of-accounts'
      ).then((m) => m.ChartOfAccounts),
    'fiscal-period': () =>
      import('@ui-nuvertos/shared/masters/fiscal-period/fiscal-period').then(
        (m) => m.FiscalPeriod
      ),
    'asset-group': () =>
      import('@ui-nuvertos/shared/masters/asset-group/asset-group').then(
        (m) => m.AssetGroup
      ),
    'asset-sub-group': () =>
      import('@ui-nuvertos/shared/masters/asset-sub-group/asset-sub-group').then(
        (m) => m.AssetSubGroup
      ),
    'maintenance-type': () =>
      import('@ui-nuvertos/shared/masters/maintenance-type/maintenance-type').then(
        (m) => m.MaintenanceType
      ),
    'department': () =>
      import('@ui-nuvertos/shared/masters/department/department').then(
        (m) => m.Department
      ),
    'asset-write-off-reason': () =>
      import('@ui-nuvertos/shared/masters/asset-write-off-reason/asset-write-off-reason').then(
        (m) => m.AssetWriteOffReason
      ),
    'asset-maintenance-issue-type': () =>
      import('@ui-nuvertos/shared/masters/asset-maintenance-issue-type/asset-maintenance-issue-type').then(
        (m) => m.AssetMaintenanceIssueType
      ),
    'asset-maintenance-warranty-type': () =>
      import('@ui-nuvertos/shared/masters/asset-maintenance-warranty-type/asset-maintenance-warranty-type').then(
        (m) => m.AssetMaintenanceWarrantyType
      ),
    'sub-location': () =>
      import('@ui-nuvertos/shared/masters/sub-location/sub-location').then(
        (m) => m.SubLocationComponent
      ),
    'bank-details': () =>
      import('@ui-nuvertos/shared/masters/bank-details/bank-details').then(
        (m) => m.BankDetails
      ),
  };

  // All other masters use the generic component
  const genericMasterLoader = () =>
    import('@ui-nuvertos/shared/masters/generic-master/generic-master').then(
      (m) => m.GenericMaster
    );

  return mastersItem.children
    .map((child: any) => {
      const routePath = child.route?.replace('/settings/masters/', '') || '';
      const loadComponent = componentMap[routePath] || genericMasterLoader;

      return {
        path: routePath,
        loadComponent,
        data: {
          breadcrumb: child.label,
          module_id: child.module_id,
          sub_module_id: child.sub_module_id,
          actions: {
            showFavorite: true,
            showSettings: true,
            showBulkUpload: false,
            showBack: false,
            // Exclude Create button for fiscal-period as it has Super Admin check in component
            redirectButtons: routePath === 'fiscal-period' ? [] : [
              {
                label: 'Create',
                route: `/settings/masters/${routePath}/create`,
              },
            ],
          },
        },
        children: [
          {
            path: 'create',
            loadComponent,
            data: { breadcrumb: `Create ${child.label}` },
          },
          {
            path: 'edit/:id',
            loadComponent,
            data: { breadcrumb: `Edit ${child.label}` },
          },
          {
            path: 'view/:id',
            loadComponent,
            data: { breadcrumb: `View ${child.label}` },
          },
        ],
      };
    })
    .filter((route: any) => route !== null) as Routes;
}

function generateAccountSettingsRoutes(): Routes {
  const settingsItem = sidebarItems.find((item) => item.key === 'settings');
  if (!settingsItem?.children) return [];

  const accountSettingsItem = settingsItem.children.find(
    (child: any) => child.label === 'Account Settings'
  ) as any;
  if (!accountSettingsItem?.children) return [];

  const routes: Routes = [];

  accountSettingsItem.children.forEach((child: any) => {
    const routePath =
      child.route?.replace('/settings/account_settings/', '') || '';

    if (routePath === 'users') {
      // List route
      routes.push({
        path: 'users',
        loadComponent: () =>
          import('@ui-nuvertos/shared/user-list/user-list').then(
            (m) => m.UserList
          ),
        data: {
          breadcrumb: child.label,
          module_id: child.module_id,
          sub_module_id: child.sub_module_id,
          actions: {
            showFavorite: true,
            showSettings: true,
            showBulkUpload: false,
            redirectButtons: [
              {
                label: 'Create User',
                route: '/settings/account_settings/users/create',
              },
            ],
          },
        },
      });

      // Create route
      routes.push({
        path: 'users/create',
        loadComponent: () =>
          import('@ui-nuvertos/shared/user/user').then((m) => m.User),
        data: { breadcrumb: `Create User` },
      });

      // Edit route
      routes.push({
        path: 'users/edit/:userId',
        loadComponent: () =>
          import('@ui-nuvertos/shared/user/user').then((m) => m.User),
        data: { breadcrumb: `Edit User` },
      });

      // View route
      routes.push({
        path: 'users/view/:userId',
        loadComponent: () =>
          import('@ui-nuvertos/shared/user/user').then((m) => m.User),
        data: { breadcrumb: `View User` },
      });
    }
    // Note: Roles routes are defined directly in account_settings children array
    // to ensure they're registered before the catch-all route
  });

  return routes;
}
